// vuex 在页面刷新时会重置，先缓存在会话存储中
export default {
  // 设置用户信息
  SET_USER_INFO (state, data) {
    state.userInfo = data
    sessionStorage.setItem('userInfo', JSON.stringify(data))
  },
  SET_PROJECT_INFO (state, data) {
    state.projectInfo = {...data}
    sessionStorage.setItem('projectInfo', JSON.stringify(data))
  },
  updateInterval (state, data) {
    state.interval = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js